import styled, { css } from 'styled-components';

import { Button as DefaultButton } from '@xing-com/button';
import * as layoutTokens from '@xing-com/layout-tokens';

export const Button = styled(DefaultButton)<{ $isArmstrong: boolean }>`
  ${({ $isArmstrong }) =>
    $isArmstrong &&
    css`
      display: none;

      @media ${layoutTokens.mediaWide} {
        display: flex;
      }
    `}
`;
